// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components-wpbbsa/calculators-personalloans-test/calculators-personalloans-test.component.scss
// module id = 246
// module chunks = 0